import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  alpha,
} from '@mui/material';
import { MenuItemType, useNavItems } from './NavItems';

interface MobileDrawerProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onNavigate: (path: string) => void;
}

export const MobileDrawer: React.FC<MobileDrawerProps> = ({
  anchorEl,
  onClose,
  onNavigate,
}) => {
  const theme = useTheme();
  const location = useLocation();
  const menuItems = useNavItems();

  const renderFlatItems = (items: MenuItemType[]): React.ReactNode[] => {
    const result: React.ReactNode[] = [];
    for (const item of items) {
      if (item.path) {
        result.push(
          <MenuItem
            key={item.text}
            selected={location.pathname === item.path}
            onClick={() => {
              if (item.path) {
                onNavigate(item.path);
              }
              onClose();
            }}
            sx={{
              '&.Mui-selected': {
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </MenuItem>,
        );
      }
      if (item.children) {
        result.push(...renderFlatItems(item.children));
      }
    }
    return result;
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      PaperProps={{ sx: { mt: 1, minWidth: 200 } }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      {renderFlatItems(menuItems)}
    </Menu>
  );
};
